<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t2"><img alt="img2.jpg" height="48" src="Images/img2.jpg" width="48"/></span></p>
<p class="p0"><span class="t2">Publié par</span></p>
<p class="p1"><span class="t3">D</span><span class="t4">REAMSPINNER</span> <span class="t3">P</span><span class="t4">RESS</span></p>
<p class="p0"><span class="t2">5032 Capital Circle SW, Suite 2, PMB# 279, Tallahassee, FL 32305-7886 USA</span></p>
<p class="p1"><span class="t2">http://www.dreamspinnerpress.com/</span></p>
<p class="p2"><span class="t2">Ceci est une œuvre de fiction. Les noms, les personnages, les lieux et les faits décrits ne sont que le produit de l’imagination de l’auteur, ou utilisés de façon fictive. Toute ressemblance avec des personnes ayant réellement existé, vivantes ou décédées, des établissements commerciaux ou des événements ou des lieux ne serait que le fruit d’une coïncidence.</span></p>
<p class="p3"><span class="t2">La Rançon</span></p>
<p class="p3"><span class="t2">Copyright de l'édition française © 2015 Dreamspinner Press.</span></p>
<p class="p3"><span class="t2">Titre original: Ransom</span></p>
<p class="p3"><span class="t2">© 2013 Lee Rowan.</span></p>
<p class="p2"><span class="t2">Traduit de l’anglais par Anne Solo.</span></p>
<p class="p3"><span class="t2">Illustration de la couverture :</span></p>
<p class="p3"><span class="t2">© 2013 Reese Dante.</span></p>
<p class="p3"><span class="t2">http://www.reesedante.com</span></p>
<p class="p2"><span class="t2">Les éléments de la couverture ne sont utilisés qu’à des fins d’illustration et toute personne qui y est représentée est un modèle</span></p>
<p class="p2"><span class="t2">Tout droit réservé. Aucune partie de cet e-book ne peut être reproduite ou transférée d’aucune façon que ce soit ni par aucun moyen, électronique ou physique sans la permission écrite de l’éditeur, sauf dans les endroits où la loi le permet. Cela inclut le photocopiage, les enregistrements et tout système de stockage et de retrait d’information. Pour demander une autorisation, et pour toute autre demande d’information, merci de contacter Dreamspinner Press, 5032 Capital Cir. SW, Ste 2 PMB# 279, Tallahassee, FL 32305-7886, USA http://www.dreamspinnerpress.com/.</span></p>
<p class="p3"><span class="t2">Édition e-book en français : 978-1-63476-969-3</span></p>
<p class="p3"><span class="t2">Édition imprimée en français : 978-1-63476-968-6</span></p>
<p class="p3"><span class="t2">Première édition française : octobre 2015</span></p>
<p class="p3"><span class="t2">Troisième édition : septembre 2014</span></p>
<p class="p3"><span class="t2">Seconde édition (papier) publiée par Cheyenne Publishing, 2009</span></p>
<p class="p3"><span class="t2">Seconde édition (ebook) publiée par Bristlecone Pine Press, 2009</span></p>
<p class="p2"><span class="t2">Première édition (papier et ebook) publiée par Linden Bay Romance, LLC, 2006</span></p>
<p class="p0"><span class="t2">Édité aux Etats-Unis d’Amérique.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?6aa37738